import { useEffect, useState } from "react";

type Theme = "dark" | "light";

const STORAGE_KEY = "gk:theme";

export function currentTheme(): Theme {
  if (typeof window === "undefined") return "dark";
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === "light" || stored === "dark") return stored;
  return "dark";
}

export function applyTheme(t: Theme) {
  if (typeof document === "undefined") return;
  document.documentElement.dataset.theme = t;
  document.documentElement.style.colorScheme = t;
  localStorage.setItem(STORAGE_KEY, t);
}

export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(() => currentTheme());
  useEffect(() => {
    applyTheme(theme);
  }, [theme]);
  return (
    <button
      onClick={() => setTheme((t) => (t === "dark" ? "light" : "dark"))}
      className="text-xs text-slate-400 hover:text-slate-100 flex items-center gap-1.5"
      title={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
    >
      <span>{theme === "dark" ? "🌙" : "☀"}</span>
      <span>{theme === "dark" ? "Dark" : "Light"}</span>
    </button>
  );
}
